<template lang="pug">
  #topExercise.question-detail(v-if="item !== undefined && item !== null")
    .item-question.col-md-12
      .big-audio(v-if="item.detailLink && item.detailLink !== undefined && item.detailLink.length > 0")
        audio(id="player" controls width="50%")
          source(:src="item.detailLink" type="audio/mp3")
      .big-question {{$mycontroller.stripHtml(item.content)}}
    .item-question-number
      .col-md-12
        span {{$t('landing.exercise.question')}} {{current}}/{{total}}
    .item-question.col-md-12
      .small-question {{$mycontroller.stripHtml(item.detailContent)}}
    .item-answer.col-md-12(v-if="item.detailType === 1")
      .item-answer-me.choosen(v-if="item.detailAnswers !== null")
        .answer-charactor.result-page(v-for="(itemAnswer, index) in item.detailAnswers" :class="[item.detailStatus === 2 ? '' : (item.detailStatus === 1 && answerIDs !== null && answerIDs.includes(itemAnswer.id) ? 'success' : (item.detailStatus === 0 && answerIDs !== null && answerIDs.includes(itemAnswer.id) ? 'danger': '')) ]")
          label {{$mycontroller.convertToAlphabet(index)}}. {{$mycontroller.stripHtml(itemAnswer.content)}}
          span.material-icons.format-icon(v-if="item.detailStatus === 1 && answerIDs !== null && answerIDs.includes(itemAnswer.id)") done
          span.material-icons.format-icon(v-else-if="item.detailStatus === 0 && answerIDs !== null && answerIDs.includes(itemAnswer.id)") clear
    .item-answer.col-md-12(v-else)
      label {{$t('landing.exercise.answer')}}
      .item-answer-me.answer-text.success(v-if="item.detailType === 2 && item.detailStatus === 1 && $mycontroller.stripHtml(item.detailValueContent).length > 0" v-html="rawHtml(item.detailValueContent)")
      .item-answer-me.answer-text.danger(v-else-if="item.detailType === 2 && item.detailStatus === 0 && $mycontroller.stripHtml(item.detailValueContent).length > 0" v-html="rawHtml(item.detailValueContent)")
      .item-answer-me.answer-text(v-else-if="item.detailType === 2 && item.detailStatus === 2" v-html="rawHtml(item.detailValueContent)")
    .clearfix
    .item-result
      #topSystemAnswer.item-result-top
        label {{$t('landing.exercise.answer_sys')}}
        .item-answer-system(v-html="rawHtml(item.detailValue)" v-if="item.detailType === 2")
        .item-answer-system(v-else-if="item.detailType === 1" v-html="getAnswerCorrect(item.detailAnswers)")
      .item-result-center
        label {{$t('landing.exercise.explain')}}
        .item-result-explain(v-html="rawHtml(explain)")
      #topSystemRelate.item-result-bottom
        label {{$t('landing.exercise.relate')}}
        .box-owl-carousel
          carousel.owl-carousel(:key="refresh" :center="true" :responsive="{0:{items:1},600:{items:2}, 768:{items:3}}" :autoplay="true" :dots="false" :nav="false" v-if="lstLessons && lstLessons !== null" ref="owlCarousel")
            template(slot="prev")
              button.prev
                i.fa.fa-arrow-left
            FrontItem(:key="index" v-for="(lesson, index) in lstLessons" :lesson="lesson" :url="getLinkMore()" :obj_id="lesson.id" ref="frontItem")
            template(slot="next")
              button.next
                i.fa.fa-arrow-right
    .clearfix
    .box-button-help
      .item-fixed-button
        .item-button(@click="gotoElement('topExercise')" :class="[isMobile() ? 'click-button' : 'hover-button']")
          img(src="../../../../assets/images/faces/ic_noidungcauhoi_24px@2x.png")
          span {{$t('landing.exercise.buttons.button1')}}
        .item-button(@click="gotoElement('topSystemAnswer')" :class="[isMobile() ? 'click-button' : 'hover-button']")
          img(src="../../../../assets/images/faces/ic_idea_24px@2x.png")
          span {{$t('landing.exercise.buttons.button2')}}
        .item-button(@click="gotoElement('topSystemRelate')" :class="[isMobile() ? 'click-button' : 'hover-button']")
          img(src="../../../../assets/images/faces/ic_link_24px@2x.png")
          span {{$t('landing.exercise.buttons.button3')}}
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import carousel from 'vue-owl-carousel'
import FrontItem from '../Lesson/item'
// import $ from 'jquery'
export default {
  components: {
    FrontItem,
    carousel
  },
  props: {
    item: Object,
    current: Number,
    total: Number,
    pcInfo: Object,
    arrIDs: Array
  },
  data() {
    return {
      refresh: 0,
      lstLessons: [],
      answerIDs: this.arrIDs,
      statusAnswer: 2,
      message: this.$t('home.comming_soon'),
      explain: this.item.detailExplain
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    getAnswerCorrect(answers) {
      var returnData = answers.filter(a => a.is_correct === true)
      if (Object.entries(returnData).length > 0) {
        var strAnswer = ''
        for (let index = 0; index < returnData.length; index++) {
          const element = returnData[index]
          strAnswer += this.$mycontroller.convertToAlphabet(index) + '. ' + this.$mycontroller.stripHtml(element.content) + '<br/>'
        }
        return strAnswer
      }
    },
    getLinkMore() {
      return 'landing/' + this.pcInfo.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.pcInfo.name) + '-' + this.pcInfo.id
    },
    rawHtml(html) {
      return html
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    gotoElement(idElement) {
      document.getElementById(idElement).scrollIntoView({behavior: 'smooth'})
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  async mounted () {
    this.lstLessons = []
    var objWhere = {
      question_id: {_eq: this.item.detailQuestionID}
    }
    var variables = {
      where: objWhere,
      orderBy: {updated_at: 'desc'}
    }
    await this.$apollo.query({
      query: gql(graphql.GET_LESSON_OF_QUESTION),
      variables: variables
    }).then((response) => {
      if (response.data.lesson_question && response.data.lesson_question.length > 0) {
        this.lstLessons = response.data.lesson_question[0].v_front_lesson
        this.explain = response.data.lesson_question[0].questionDetail.explain
      }
    }).catch((error) => {
      if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
        this.$router.go(0, this.$route.params, this.$route.query)
      }
    })
    // lấy kết quả submit
    var variablesDONE = {
      where: {
        user_id: {_eq: this.$store.getters.user},
        exercise_id: {_eq: this.item.exercise.id},
        status: {_eq: 3},
        is_delete: {_eq: false}
      }
    }
    await this.$apollo.query({
      query: gql(graphql.GET_RESULT_QUESTION_USER_EXCERCISE),
      fetchPolicy: 'no-cache',
      variables: variablesDONE
    }).then((response) => {
      if (response.data.result && response.data.result !== null) {
      } else this.$router.push({path: '/'})
    }).catch((error) => {
      if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
        this.$router.go(0, this.$route.params, this.$route.query)
      }
    })
    this.refresh++
  },
  apollo: {
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// questionResult.vue?6bc66a60